import { Pipe, PipeTransform } from '@angular/core';
import { IngredientChoice } from 'ngx-web-api';

@Pipe({
  name: 'filterOutInstruction',
})
export class FilterOutInstructionPipe implements PipeTransform {
  transform(choices: IngredientChoice[], args?: any): any {
    if (!!choices && choices.length > 0) {
      return choices.filter(c => !c.isInstructions);
    }
    return choices;
  }
}
